import { SearchInput } from '@/components/ui/search-input'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { useDebouncedInput } from '@/hooks/useDebouncedInput'
import { EmailAttachmentFilter, useEmailSenders } from '@/models/internalEmail'

const ANY_SENDER = '__any__'

interface Props {
  q: string
  fromEmail: string
  hasAttachments: EmailAttachmentFilter
  onQ: (value: string) => void
  onFromEmail: (value: string) => void
  onHasAttachments: (value: EmailAttachmentFilter) => void
}

export function EmailFilters(props: Props) {
  const { data: senders = [] } = useEmailSenders()
  const { inputValue, setInputValue } = useDebouncedInput(props.q, props.onQ)

  return (
    <div className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row sm:flex-wrap sm:items-center">
      <SearchInput
        value={inputValue}
        onValueChange={setInputValue}
        placeholder="Search text, or paste an ID…"
        title="Searches subject, body, from, to and cc. Paste an org, application, sales lead, message or agent run ID to scope to that record."
        className="w-full sm:max-w-sm sm:flex-1"
      />

      <Select
        value={props.fromEmail || ANY_SENDER}
        onValueChange={(value) => props.onFromEmail(value === ANY_SENDER ? '' : value)}
      >
        <SelectTrigger className="w-full sm:w-64">
          <SelectValue placeholder="Any sender" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={ANY_SENDER}>Any sender</SelectItem>
          {senders.map((sender) => (
            <SelectItem key={sender} value={sender}>
              {sender}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Select
        value={props.hasAttachments}
        onValueChange={(value) => props.onHasAttachments(value as EmailAttachmentFilter)}
      >
        <SelectTrigger className="w-full sm:w-48">
          <SelectValue placeholder="Any attachments" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={EmailAttachmentFilter.ANY}>Any attachments</SelectItem>
          <SelectItem value={EmailAttachmentFilter.WITH}>Has attachments</SelectItem>
          <SelectItem value={EmailAttachmentFilter.WITHOUT}>No attachments</SelectItem>
        </SelectContent>
      </Select>
    </div>
  )
}
